module.exports = __webpack_public_path__ + "img/md.a776ca6.svg";